import PropTypes from 'prop-types';

export const BasicVehicleSpecs = PropTypes.shape({
  make: PropTypes.string,
  makeId: PropTypes.number,
  model: PropTypes.string,
  modelId: PropTypes.number,
  year: PropTypes.number,
});

export const SavedVehicle = PropTypes.shape({
  guid: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  make: PropTypes.string.isRequired,
  makeId: PropTypes.number,
  manuallyEntered: PropTypes.bool,
  model: PropTypes.string.isRequired,
  modelId: PropTypes.number,
  nickname: PropTypes.string,
  odometerUnits: PropTypes.string,
  trim: PropTypes.string,
  type: PropTypes.shape({
    displayName: PropTypes.string,
    typeIdentifier: PropTypes.string,
  }),
  vin: PropTypes.string,
  year: PropTypes.number.isRequired,
});

export const VehicleOptionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
});

export const VehicleRecallResult = PropTypes.shape({
  affectedUnits: PropTypes.number,
  component: PropTypes.string,
  consequence: PropTypes.string,
  manufacturer: PropTypes.string,
  notes: PropTypes.string,
  ownerNotified: PropTypes.string,
  recallDate: PropTypes.string,
  recallId: PropTypes.string,
  remedy: PropTypes.string,
  reportFiledBy: PropTypes.string,
  summary: PropTypes.string,
  vehicles: PropTypes.arrayOf(
    PropTypes.shape({
      make: PropTypes.string,
      model: PropTypes.string,
      year: PropTypes.number,
      components: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
});

export const IdNamePair = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
});
